// extracted by mini-css-extract-plugin
module.exports = {"loader":"page-loader_loader__xFIze","tip":"page-loader_tip__1Us3q"};